import { PhotoManager } from "./photo-manager";
import { consoleMsg } from "../shared/utility";
import { mkAbs } from "../shared/page-init.js";

const app = window.app;

export class DamagePhotoManager extends PhotoManager {
	constructor(name) {
		super(name);
	}
	async deletePhoto(buttonElement) {
		const storageKey = app.state.storageKey;
		let photoRow;
		let deleteButton;
		if (app.state.currentPage === "page2") {
			photoRow = document.getElementById("photoRow" + buttonElement.id.substr(-1));
			deleteButton = document.getElementById("deletePhotoButton" + buttonElement.id.substr(-1));
		} else {
			photoRow = document.getElementById("interiorPhotoRow" + buttonElement.id.substr(-1));
			deleteButton = document.getElementById("interiorDeletePhotoButton" + buttonElement.id.substr(-1));
		}
		consoleMsg("PHOTO ROW = ", photoRow);
		const keys = await store.keys();
		consoleMsg("DELETE PHOTO CALLED ON KEYS: ", keys);
		let lastPhoto;
		consoleMsg(photoRow.id);
		if (photoRow.children.length > 0) {
			lastPhoto = photoRow.lastChild.children[0];
			let photoId = lastPhoto.id;
			const expectedKey = `${storageKey}_${photoId}`;
			for (const key of keys) {
				if (key === expectedKey) {
					consoleMsg("DAMAGE PHOTO MANAGER DELETE METHOD CALLED...");
					consoleMsg("Deleting photo ", key);
					await store.remove(key);
				}
			}
			photoRow.removeChild(photoRow.lastChild);
			setTimeout(() => {
				this.disableDeletePhotoButton(deleteButton, photoRow);
			}, 100);
		}
	}
	disableDeletePhotoButton(button, photoRow) {
		if (photoRow.children.length === 0) {
			consoleMsg("Disabling Delete button...");
			button.setAttribute("disabled", "");
		}
	}

	enableDeleteButton(col) {
		if (!col || !col.parentElement) return;

		const parentId = col.parentElement.id;
		const index = parentId.charAt(parentId.length - 1);

		const deleteButton = parentId.startsWith("interiorPhotoRow")
			? document.getElementById("interiorDeletePhotoButton" + index)
			: document.getElementById("deletePhotoButton" + index);

		if (deleteButton) {
			deleteButton.removeAttribute("disabled");
		}
	}

	async restoreDamagePhoto(rowElement, photoId) {
		const storageKey = app.state.storageKey;
		const key = `${storageKey}_${photoId}`;
		const photoData = await store.get(key);
		if (photoData && rowElement) {
			const img = rowElement.querySelector("img");
			if (img) {
				img.src = "data:image/jpeg;base64," + photoData.photo;
				consoleMsg(`Restored damage photo for ${photoId}`);
			}
		}
	}

	async restoreAllDamagePhotos() {
		const storageKey = app.state.storageKey;
		const keys = await store.keys();
		const photoKeys = keys.filter((k) => k.startsWith(`${storageKey}_photo`));

		// Clear all photo rows before restoring
		document.querySelectorAll('[id^="photoRow"]').forEach((row) => {
			while (row.firstChild) row.removeChild(row.firstChild);
		});

		for (const key of photoKeys) {
			const currentPhoto = await store.get(key);
			const row = currentPhoto.row;
			const base64Pic = currentPhoto.photo;
			const imgRow = document.getElementById(row);
			const questionId = currentPhoto.questionId;

			if (imgRow) {
				const numberOfPhotos = imgRow.children.length;
				const photoId = String(numberOfPhotos + 1);

				// Create the ion-col wrapper
				const component = document.createElement("ion-col");
				component.setAttribute("size", "3");

				// Create the image
				const img = new Image();
				img.src = "data:image/jpeg;base64," + base64Pic;
				img.id = "photo" + photoId + "-" + imgRow.id;
				img.classList.add("landscape-img");

				// Append to DOM
				imgRow.append(component);
				component.append(img);

				// Enable delete button after restore
				setTimeout(() => {
					this.enableDeleteButton(component);
				}, 200);
			}
		}
		consoleMsg("DAMAGE PHOTO MANAGER RESTORE ALL DAMAGE PHOTOS CALLED...");
	}

	async savePhoto(imgRow, flag = false, questionId, img) {
		consoleMsg("imgRow = ", imgRow);
		consoleMsg("Flag = ", flag);
		const i = new Image();

		// Create an ion-col element as a wrapper to hold the photo
		const component = document.createElement("ion-col");
		const numberOfPhotos = imgRow.children.length;
		const photoId = String(numberOfPhotos + 1);

		// Set size to 3 of available 12 columns (25% column width)
		component.setAttribute("size", "3");
		i.src = img;
		i.id = "photo" + photoId + "-" + imgRow.id;
		i.classList.add("landscape-img");
		imgRow.append(component);
		component.append(i);

		setTimeout(() => {
			this.enableDeleteButton(component);
		}, 200);

		// If flag is false, store the photo in Ionic Storage
		if (!flag) {
			await this.constructor.storePicDb(i, imgRow, questionId);
		}
	}

	async handlePhotoClick(event, rowPrefix = "photoRow", takePrefix = "takePhotoButton", deletePrefix = "deletePhotoButton") {
		const button = event.target;
		const rowId = button.id.replace(takePrefix, rowPrefix);
		const rowElement = document.getElementById(rowId);

		if (!rowElement) {
			console.error(`Row element not found for button ID: ${button.id}`);
			return;
		}

		consoleMsg("Button clicked...");
		const questionId = button.dataset.questionId;

		// Desktop has no camera app, so both sheet options would do the same thing
		if (!PhotoManager.supportsCameraCapture()) {
			await this.pickPhoto(rowElement, button, questionId);
			return;
		}

		const actionSheet = document.createElement("ion-action-sheet");
		actionSheet.header = "Add Photo";
		actionSheet.buttons = [
			{
				text: "Take Photo",
				icon: "camera",
				handler: async () => await this.takePhoto(rowElement, button, questionId),
			},
			{
				text: "Choose from Gallery",
				icon: "image",
				handler: async () => await this.pickPhoto(rowElement, button, questionId),
			},
			{
				text: "Cancel",
				role: "cancel",
				icon: "close",
			},
		];

		document.body.appendChild(actionSheet);
		await actionSheet.present();
	}

	async takePhoto(rowElement, buttonElement, questionId) {
		await this.addPhoto(rowElement, buttonElement, questionId, "camera-input");
	}

	async pickPhoto(rowElement, buttonElement, questionId) {
		await this.addPhoto(rowElement, buttonElement, questionId, "gallery-input");
	}

	async addPhoto(rowElement, buttonElement, questionId, inputId) {
		try {
			const file = await PhotoManager.captureViaFileInput(inputId);
			const webPath = URL.createObjectURL(file);

			consoleMsg("DAMAGE PHOTO MANAGER SAVE PHOTO CALLED");
			consoleMsg("addPhoto rowElement: ", rowElement);
			consoleMsg("addPhoto buttonElement: ", buttonElement);
			consoleMsg("addPhoto questionId: ", questionId);
			this.savePhoto(rowElement, false, questionId, webPath);
		} catch (error) {
			consoleMsg("Error adding photo: ", error);
		}
	}

	updateCarPhotos() {
		const keys = Object.keys(app.state.photoData);
		consoleMsg("updateCarPhotos function called...");
		for (let i = 0; i < keys.length; i++) {
			const key = keys[i];
			if (app.state.photoData[key].updated === true) {
				const element = document.getElementById(key);
				const image = element.querySelector("img");

				const base = (app.settings.base || "/").replace(/\/+$/, "");
				const target = app.state.photoData[key].src;

				//prettier-ignore
				const rel = /^(https?:|data:|blob:)/i.test(target) ? target : 
            base && target?.startsWith(base + "/") ? target.slice(base.length + 1) : 
            target?.startsWith("/assets/") ? target.slice(1) : target;

				const resolved = mkAbs(rel);

				if (image.src !== resolved) {
					image.src = "";
					setTimeout(() => {
						image.setAttribute("src", resolved);
						image.src = resolved;
						hideSkeleton(element);
					}, 50);
				}
			}
		}
	}

	attachPhotoEventListeners(context = document, rowPrefix = "photoRow", takePrefix = "takePhotoButton", deletePrefix = "deletePhotoButton") {
		const takeButtons = context.querySelectorAll(`ion-button[id^="${takePrefix}"]`);
		const deleteButtons = context.querySelectorAll(`ion-button[id^="${deletePrefix}"]`);
		takeButtons.forEach((button) => {
			button.addEventListener("click", (event) => this.handlePhotoClick(event, rowPrefix, takePrefix, deletePrefix));
		});
		deleteButtons.forEach((button) => {
			button.addEventListener("click", async (event) => {
				await this.deletePhoto(event.target);
			});
		});
	}
}
